var _dec, _class;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import './AirPagination.css';
import AirButton from 'air-button';
import { ArrowLeftIcon, ArrowRightIcon } from 'air-icons';
import { inject, observer } from 'mobx-react';
var AirPagination = (_dec = inject('translationsStore'), _dec(_class = observer(_class = function (_Component) {
  _inherits(AirPagination, _Component);

  function AirPagination() {
    _classCallCheck(this, AirPagination);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AirPagination.prototype.render = function render() {
    var _props = this.props,
        total = _props.total,
        pageSize = _props.pageSize,
        translationsStore = _props.translationsStore,
        currentPage = _props.currentPage,
        hideOnSinglePage = _props.hideOnSinglePage,
        description = _props.description;
    var lastPage = Math.ceil(total / pageSize);
    return React.createElement('div', {
      className: 'AirPagination lastPage-' + lastPage + ' ' + (hideOnSinglePage ? 'hideOnSinglePage' : '') + ' '
    }, React.createElement('div', {
      className: 'totals'
    }, React.createElement('div', null, pageSize * (currentPage - 1) + 1, ' '), React.createElement('div', {
      className: 'dash'
    }, '-'), React.createElement('div', null, Math.min(pageSize * (currentPage - 1) + pageSize, total), ' '), React.createElement('div', null, '\xA0', translationsStore.translate('of'), '\xA0'), React.createElement('div', null, total), React.createElement('div', {
      className: 'description'
    }, description)), React.createElement('div', {
      className: 'arrows'
    }, React.createElement('div', {
      className: 'arrow left'
    }, React.createElement(AirButton, {
      className: 'AirPaginationButton ' + (currentPage === 1 ? 'disabled' : ''),
      onClick: this.props.prev,
      icon: React.createElement(ArrowLeftIcon, null)
    })), React.createElement('div', {
      className: 'arrow right'
    }, React.createElement(AirButton, {
      className: 'AirPaginationButton ' + (currentPage === lastPage ? 'disabled' : ''),
      onClick: this.props.next,
      icon: React.createElement(ArrowRightIcon, null)
    }))));
  };

  return AirPagination;
}(Component)) || _class) || _class);
export { AirPagination as default };